
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
    filter:''
}
export const Sections = createAsyncThunk('section-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const SectionsSlice = createSlice({

    name: 'Sections-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [Sections.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [Sections.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [Sections.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = SectionsSlice.actions;
export default SectionsSlice.reducer